export const PACKAGE_NAME = '@bem-plus/class-generator'
export const AUTO_GENERATED_DISCLAIMER = 'This file was automatically generated by the bem-plus package.'
export const RESERVED_NAMES = ['apply', 'bind', 'call', 'constructor', 'hasOwnProperty', 'isPrototypeOf', 'propertyIsEnumerable', 'toString', 'toLocaleString', 'valueOf', 'prototype', 'length', 'el']
